import React from 'react'

const Loading = () => (
  <div >
    <h1 class="display-3 text-center">Loading...</h1>
  </div>
)

export default Loading
